export const mobileChildren: Record<string, never> = {};
